import { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { IAppointment } from "../../providers/user/types";

import { api } from "../../lib/api";

import { usePartnerData } from "../../providers/partnerData";

import { Header } from "../../components/Elements/Header";
import Footer from "../../components/Elements/Footer";

const WaitRoomPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const teleCRef = useRef<NodeJS.Timeout>();
  const { partnerUrl } = usePartnerData();

  const enteredOnRoom = async () => {
    try {
      await api.put(`Attendance/waitRoom/${appointment.legacyId}`);
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetData = async () => {
    try {
      const response = await api.get(`/Attendance/teleCheck/${appointment.id}`);

      if (response.data.medicEntered) {
        navigate(`/${partnerUrl}/atendimento`, { state: appointment });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (location.state) {
      enteredOnRoom();
      teleCRef.current = setInterval(handleGetData, 5000);
      return () => {
        clearInterval(teleCRef.current);
      };
    }
  }, []);

  // Essa condição deve ficar após o useEffect e antes da desestruturação de location.state
  // para não dar erro quando usuário tentar acessar essa página pela url
  if (!location.state) {
    return <Navigate to={`/${partnerUrl}`} />;
  }

  const { appointment } = location.state as IAppointment;

  return (
    <>
      <Header />
      <div id="wrapper" className="p-0">
        <div className="page-header flex-fill justify-content-start">
          <div className="shape"></div>
          <div className="container position-relative py-5">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <h1 className="text-center mb-5">Atendimento</h1>

                <div className="card text-body bg-light p-3 px-md-5 py-md-4">
                  <div className="text-center">
                    <h3 className="mb-4">
                      <span className="text-primary">Aguarde</span>, seu
                      atendimento é o{" "}
                      <span className="bold text-primary">próximo</span> da
                      waitRoom!
                    </h3>
                  </div>
                  <div className="row align-items-center py-3">
                    <div className="col col-auto">
                      <i className="h1 fw-bold mb-0 las la-fw la-window-close text-primary"></i>
                    </div>
                    <div className="col">
                      <b>Aguarde com esta janela aberta!</b>
                      <br />
                      Ao fecha-la, você encerrará o atendimento.
                    </div>
                  </div>
                  <div className="row align-items-center py-3">
                    <div className="col col-auto">
                      <i className="h1 fw-bold mb-0 las la-fw la-sync text-primary"></i>
                    </div>
                    <div className="col">
                      Assim que o profissional de saúde estiver disponível você
                      será redirecionado automaticamento para a teleorientação!
                    </div>
                  </div>
                  <div className="row align-items-center py-3">
                    <div className="col col-auto">
                      <i className="h1 fw-bold mb-0 las la-fw la-microphone text-primary"></i>
                    </div>
                    <div className="col">
                      Quando o sistema solicitar{" "}
                      <b>acesso a sua câmera e microfone</b>, por favor,{" "}
                      <b>aceite</b> para que a tela orientação possa ocorrer;
                    </div>
                  </div>
                  <div className="text-center pt-4">
                    <button
                      onClick={() => navigate(-1)}
                      className="btn btn-outline-secondary"
                    >
                      <i className="las la-arrow-left me-2"></i>Voltar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WaitRoomPage;
